<ng-template [ngIf]="element.legale?.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Cognome e Nome'"
	[valueInput]="element.legale?.nominativo"></div>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Codice Fiscale'"
	[valueInput]="element.legale?.codiceFiscale"></div>
</ng-template>
<ng-template [ngIf]="element.legale?.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Ragione sociale'"
	[valueInput]="element.legale?.nominativo"></div>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Partita iva'"
	[valueInput]="element.legale?.partitaIva"></div>
</ng-template>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
	[labelInput]="'Tipo legale'"
	[valueInput]="element.categoriaLegaleIncaricato.label"></div>
<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'date'"
	[labelInput]="'Data conferimento incarico'"
	[valueInput]="element.dataInizioIncarico"></div>
